<template>
    <footer>
        <div class="container">
            <router-link to="/" class="logo">
                <img src="@/assets/images/My Oxytocin Trademark.png" alt="My Oxytocin Trademark" class="trademark-logo" />
            </router-link>
            <div class="footer">
                <div class="footer-col">
                    <h4>Contact</h4>
                    <span><strong>Email: </strong><a href="mailto:support@myoxytocin.com">support@myoxytocin.com</a></span>
                    <span><strong>Phone: </strong><a href="tel:+14244029272">+1 424-402-9272</a></span>
                    <span><strong>Hours: </strong>09:00-18:00 PST</span>
                    <h4>Follow us</h4>
                    <div class="social-links">
                        <a href="https://www.instagram.com/my_oxytocin_official" target="_blank" rel="noopener noreferrer" aria-label="Instagram"
                            ><svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-instagram"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"
                                /></svg></a>
                    </div>
                    <span class="instagram-handle">@my_oxytocin_official</span>
                </div>
                <div class="footer-col">
                    <h4>About</h4>
                    <router-link to="/contact">Our Story</router-link>
                    <router-link to="/about">Our Process</router-link>
                    <router-link to="/privacy-policy">Privacy Policy</router-link>
                    <router-link to="/terms-conditions">Terms & Conditions</router-link>
                </div>
                <div class="footer-col">
                    <h4>My Account</h4>
                    <router-link to="/login">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style="margin-right: 8px; vertical-align: middle;">
                            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                            <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
                        </svg>
                        Sign In
                    </router-link>
                    <router-link to="/cart">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style="margin-right: 8px; vertical-align: middle;">
                            <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z"/>
                        </svg>
                        View Cart
                    </router-link>
                    <router-link to="/faq">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style="margin-right: 8px; vertical-align: middle;">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                        </svg>
                        FAQ
                    </router-link>
                </div>
                <div class="footer-col install">
                    <h4>Secured Payment Gateway</h4>
                    <div class="payment-methods">
                        <img src="@/assets/images/stripe-logo.svg" alt="Stripe" style="height: 40px;" />
                    </div>
                    <p style="font-size: 12px; color: #999; margin-top: 10px;">
                        Powered by Stripe - Supporting all major credit cards
                    </p>
                </div>
                <p class="copyright">
                    MyOxytocin &copy; {{date}}
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "MainFooter",
    data(){
        return {
            date: new Date().getFullYear(),
        }
    }
};
</script>

<style scoped>
footer {
    border-top: 1px solid var(--brown);
}
.footer {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-block: 4rem;
    gap: 1.5rem;
}

.logo {
    margin-block: 2rem;
    display: inline-block;
}

.trademark-logo {
    height: 80px;
    width: auto;
}


.footer-col {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    gap: 1.5rem;
}

.footer-col h4 {
    padding-bottom: 1.3rem;
}

.footer-col a {
    font-size: 1.6rem;
    display: flex;
    align-items: center;
}

.footer-col a svg {
    flex-shrink: 0;
}

.footer-col a:hover {
    color: var(--dark-green);
}

.footer-col span {
    display: block;
    font-size: 1.6rem;
}

.footer-col span a {
    color: var(--text);
    text-decoration: none;
}

.footer-col span a:hover {
    color: var(--dark-green);
}

.instagram-handle {
    font-size: 1.4rem;
    color: var(--text);
    opacity: 0.8;
}

strong {
    color: var(--text);
}

.social-links a {
    padding-right: 1.4rem;
}

.copyright {
    font-size: 1.7rem;
    width: 100%;
    text-align: center;
}

.copyright span {
    font-weight: 700;
    color: var(--dark-green);
}

.install p {
    padding-block: 0;
}

.apps {
    display: flex;
    align-items: center;
    gap: 2rem;
}

.download-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
    border: 2px solid var(--text);
    border-radius: 6px;
    padding: 8px;
    text-align: center;
}

.download-btn svg {
    font-size: 2rem;
}

.apps a:hover {
    background-color: var(--dark-green);
    color: white;
    border-color: var(--dark-green);
}

.apps a:hover p {
    color: white;
}

.payment-methods {
    display: flex;
    align-items: center;
    gap: 10px;
}
.payment-methods img {
    height: 20px;
    width: 100%;
}

.payment-methods svg:hover {
    cursor: pointer;
    color: var(--dark-green);
}

@media (max-width: 399px) {
    .download-btn p {
        font-size: 1.4rem;
    }
    .download-btn span {
        font-size: 1.4rem;
    }
}

@media (max-width: 345px) {
    .apps {
        display: flex;
        flex-direction: column;
    }
}
</style>
